function isMarkFilled(_ref) {
  var mark = _ref.mark,
    offset = _ref.offset,
    value = _ref.value,
    _ref$inverted = _ref.inverted,
    inverted = _ref$inverted === void 0 ? false : _ref$inverted;
  return inverted ? typeof offset === "number" ? mark.value <= offset || mark.value >= value : mark.value >= value : typeof offset === "number" ? mark.value >= offset && mark.value <= value : mark.value <= value;
}
export { isMarkFilled };